import { BillingInfoResponse, BillingListResponse, ChangePlanReq, CompaniesListReq, FilterResponse, StartupsListReq, PaginatedRequest, PlansResponse,UserAddressReq ,CitiesListReq, CitiesListResponse, CompanyStartMatchReq, MessagesListReq, MessageListResponse, MatchListReq, MatchListResponse, StartupStartMatchReq, CompanySendDatesReq, StartupAskNewDatesReq, StartupConfirmMatchReq, DenyMatchReq, MatchReadReq, ChangePasswordReq, CheckEmailResp, GuestUserReq, ServicesListResp, Address, AnalyticsViewReq, GetAnalyticsResponse } from './../components/types/Api';
import axios, { AxiosResponse } from "axios"
import { AddTagReq, ConstitutionStatusListResponse, EditUserstartUpReq, CorporateListRequest, DeleteTagReq, DepartmentsListResponse, EditStartUpReq, EditUserCompanyReq, LevelsResponse, PaginatedResponse, SectorsResponse, UserResponse, Response as ResponseBase } from "../components/types/Api"
import mockCorporates from "../../src/jsonMock/MockAccordion.json"
import { Billing, BillingListData, Corporate, Match, Message, OptionTypes, Role, StartUp, User } from "../components/types/types"
import { deleteCall, getCall, postCall, putCall } from "./calls/baseCall"
import { BaseResponse, DTOReasons, DTOSectors, DTOStartup, DTOStartupById, LoginResponse } from "../components/types"
import {  EmailRequest } from 'components/types/Context';
import { Service, Services } from 'components/pagine';

const matchEndpoint = 'api/Match'

const GET_USER_URL = `api/Auth/GetUser`
const POST_EMAIL_CHECK_URL = `api/Auth/CheckEmailAvailability`
const POST_REGISTER_COMPANY_GUEST_URL = `api/Auth/RegisterCompanyGuest`
const GET_SERCTOR_LIST_URL = `api/Auth/GetSectorsList`
const GET_CONSTITUTION_STATUS_LIST_URL = `api/Frontend/GetConstitutionStatusesList`
const POST_EDIT_START_UP_URL = `api/Frontend/EditStartup`
const POST_ADD_TAG_URL = `api/Frontend/AddTag`
const DELETE_TAG_URL = `api/Frontend/DeleteTag`
const GET_DEPARTMENT_LIST_URL = `api/Frontend/GetDepartmentsList`
const PUT_EDIT_USER_COMPANY_URL = `api/Frontend/EditUserCompany`
const GET_LEVEL_LIST_URL = `api/Frontend/GetLevelsList`
const GET_FILTER_LIST_URL = `api/Frontend/GetFiltersList`
const POST_COMPANIES_LIST_URL = `api/Frontend/CompaniesList`
const POST_STARTUP_LIST_URL = `api/Frontend/StartupsList`
const PUT_EDIT_USER_START_UP_URL = `api/Frontend/EditUserStartUp`

const GET_PLANS_LIST_URL = `api/Frontend/GetPlansList`
const POST_CHANGE_PLAN_URL = `api/Frontend/ChangePlan`
const POST_CITIES_LIST = `api/Auth/CitiesList`
const GET_BILLING_URL = `api/Frontend/BillingInfo`
const POST_BILLING_LIST_URL = `api/Frontend/BillingsList`

const POST_MATCH_LIST_URL = `/api/Match/MatchesList`
const POST_MESSAGE_LIST_URL = `api/Match/MessagesList`
const POST_COMPANY_START_MATCH_URL = `api/Match/CompanyStartMatch`
const POST_STARTUP_START_MATCH_URL = `api/Match/StartupStartMatch`
const POST_COMPANY_SEND_DATES_URL = `api/Match/CompanySendAvailabilityDates`
const POST_STARTUP_ASK_NEW_DATES_URL = `api/Match/StartupAskNewAvailabilityDates`
const POST_STARTUP_CONFIRM_MATCH_URL = `api/Match/StartupConfirmMatch`
const POST_DENY_MATCH_URL = `api/Match/DenyMatch`
const POST_MATCH_READ_URL = `api/Match/MatchRead`
const POST_ADDRESS_GOOGLE =`api/Frontend/SearchAdressGoogle` 


const POST_GENERATE_CODE = ``

const GET_STARTUP_BY_ID_URL = `api/Frontend/GetStartUpById`
const GET_STARTUP_BY_ID_GUEST_URL = `api/Frontend/GetStartupByIdGuest`
const GET_SECTORS_LIST = `api/Auth/GetSectorsList`
const GET_REASONS_LIST = `api/Auth/GetReasonsList`

const GET_SERVICES =`api/Frontend/GetFeaturedSercivesList`
const GET_SERVICE_BY_ID =`api/Frontend/GetFeaturedSercivesById`
const GET_SERVICE_BANNER =`api/Frontend/GetFeaturedSercivesBanner`
const GET_MATCH_SERVICE = `api/Frontend/MatchFeaturedSercives`
const POST_VISIT_ANALYTICS = 'api/Analytics/Visit'
const GET_ANALYTICS = 'api/Analytics'

export const getUser = async () => await getCall<UserResponse>(GET_USER_URL);
export const getSectorList = async () => await getCall<SectorsResponse<OptionTypes>>(GET_SERCTOR_LIST_URL);
export const getConstitutionStatusList = async () => await getCall<ConstitutionStatusListResponse<OptionTypes>>(GET_CONSTITUTION_STATUS_LIST_URL);
export const postEditStartUp = async (req: FormData) => await putCall<FormData, BaseResponse>(POST_EDIT_START_UP_URL, req);
export const postAddTag = async (req: AddTagReq) => await postCall<AddTagReq, BaseResponse>(POST_ADD_TAG_URL, req);
export const deleteTag = async (idTag: string) => await deleteCall<BaseResponse>(`${DELETE_TAG_URL}?idTag=${idTag}`);
export const getDepartmentsList = async () => await getCall<DepartmentsListResponse<OptionTypes>>(GET_DEPARTMENT_LIST_URL);
export const putEditUserCompany = async (req: EditUserCompanyReq) => await putCall<EditUserCompanyReq, BaseResponse>(PUT_EDIT_USER_COMPANY_URL, req);
export const getLevelList = async () => await getCall<LevelsResponse<OptionTypes>>(GET_LEVEL_LIST_URL);
export const getFilterList = async () => await getCall<FilterResponse>(GET_FILTER_LIST_URL);
export const postCompaniesList = async (req: CompaniesListReq) => await postCall<CompaniesListReq, PaginatedResponse<Corporate>>(POST_COMPANIES_LIST_URL, req)
export const putEditUserstartUp = async (req: EditUserstartUpReq) => await putCall<EditUserstartUpReq, BaseResponse>(PUT_EDIT_USER_START_UP_URL, req);
export const postStartupsList = async (req: StartupsListReq) => await postCall<StartupsListReq, PaginatedResponse<StartUp>>(POST_STARTUP_LIST_URL, req)
export const getPlansList = async () => await getCall<PlansResponse>(GET_PLANS_LIST_URL);
export const postSwitchPlan = async (req: ChangePlanReq) => await postCall<ChangePlanReq, BaseResponse>(POST_CHANGE_PLAN_URL, req);
export const postCitiesList = async (req: CitiesListReq) => await postCall<CitiesListReq, CitiesListResponse<OptionTypes[]>>(POST_CITIES_LIST, req)
export const postAddressByGoogle = async (req: UserAddressReq) => await postCall<UserAddressReq, ResponseBase<Address[]>>(POST_ADDRESS_GOOGLE, req);

export const getBillingInfo = async () => await getCall<BillingInfoResponse>(GET_BILLING_URL);
export const postBillingList = async (req: PaginatedRequest) => await postCall<PaginatedRequest, BillingListResponse<BillingListData>>(POST_BILLING_LIST_URL, req)

export const postMatchList = async (req: MatchListReq) => await postCall<MatchListReq, MatchListResponse<Match>>(POST_MATCH_LIST_URL, req)
export const postMessagesList = async (req: MessagesListReq) => await postCall<MessagesListReq, MessageListResponse<Message>>(POST_MESSAGE_LIST_URL, req)
export const postCompanyStartMatch = async (request: CompanyStartMatchReq) => await postCall<CompanyStartMatchReq, BaseResponse>(POST_COMPANY_START_MATCH_URL, request);
export const postStartupStartMatch = async (request: StartupStartMatchReq) => await postCall<StartupStartMatchReq, BaseResponse>(POST_STARTUP_START_MATCH_URL, request);
export const postCompanySendDates = async (request: CompanySendDatesReq) => await postCall<CompanySendDatesReq, BaseResponse>(POST_COMPANY_SEND_DATES_URL, request);
export const postStartupAskNewDates = async (request: StartupAskNewDatesReq) => await postCall<StartupAskNewDatesReq, BaseResponse>(POST_STARTUP_ASK_NEW_DATES_URL, request);
export const postStartupConfirmMatch = async (request: StartupConfirmMatchReq) => await postCall<StartupConfirmMatchReq, BaseResponse>(POST_STARTUP_CONFIRM_MATCH_URL, request);
export const postDenyMatch = async (request: DenyMatchReq) => await postCall<DenyMatchReq, BaseResponse>(POST_DENY_MATCH_URL, request);
export const postMatchRead = async (request: MatchReadReq) => await postCall<MatchReadReq, BaseResponse>(POST_MATCH_READ_URL, request);


export const getStartUpByID =
    async (idStartup: string) =>
        await getCall<ResponseBase<DTOStartupById>>(`${GET_STARTUP_BY_ID_URL}?startupId=${idStartup}`);



export const callGetStartupByIdGuest=
    async (idStartup: string) =>
        await getCall<ResponseBase<DTOStartupById>>(`${GET_STARTUP_BY_ID_GUEST_URL}?startupId=${idStartup}`);

export const postCheckEmailAvailability = async (request: EmailRequest) => await postCall< EmailRequest , CheckEmailResp>(POST_EMAIL_CHECK_URL, request);
export const postRegisterCompanyGuest =  async (request: GuestUserReq) => await postCall< GuestUserReq , LoginResponse>(POST_REGISTER_COMPANY_GUEST_URL, request);
export const getSectorsList =  async () => await getCall<DTOSectors>(`${GET_SECTORS_LIST}`);
export const getReasonsList =  async () => await getCall<DTOReasons>(`${GET_REASONS_LIST}`);

export const postServicesList =  async (request: PaginatedRequest ) => await postCall< PaginatedRequest,PaginatedResponse<Service>>(GET_SERVICES, request);
export const getServiceByID =  async (serviceId: string) => await getCall<ResponseBase<Service>>(`${GET_SERVICE_BY_ID}?serviceId=${serviceId}`);
export const getServicesBanner =  async () => await getCall<ResponseBase<Service[]>>(`${GET_SERVICE_BANNER}`);

export const getMatchFeaturedServices = async (serviceId: string)=> await getCall<BaseResponse>(`${GET_MATCH_SERVICE}?serviceId=${serviceId}`)

export const postAnalyticsView = async (request:AnalyticsViewReq) => await postCall(POST_VISIT_ANALYTICS,request)

export const getAnalytics = async () => await getCall<GetAnalyticsResponse>(GET_ANALYTICS)

export const postGenerateCode = ''